import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { NotifyService } from '../../api/NotifyAPI';
import { useAuth } from '../../store';
import { useLightMode } from '../../utils';
import s from '../../styles/notify.module.css';

// Mounted on every authenticated page. Polls the caller's notification inbox
// and, while any are pending, shows a fixed flashing modal that cannot be
// dismissed except via Close / Ignored / I Get it.
export function NotifyListener() {
  const { user } = useAuth();
  const [lightMode] = useLightMode();
  const [acking, setAcking] = useState(false);

  const { data, refetch } = useQuery({
    queryKey:        ['notify-inbox'],
    queryFn:         () => NotifyService.inbox(),
    enabled:         !!user,
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });

  const pending = data?.notifications || [];
  const current = pending[0];

  if (!user || !current) return null;

  // No colour means "no flash" — render the plain modal with its default styling.
  const flashColor = current.colors || null;

  const dismiss = async (status) => {
    if (acking) return;
    setAcking(true);
    try {
      await NotifyService.ack(current.idNotify, status);
      await refetch();
    } catch {
      // leave the modal up on failure so the message isn't lost
    } finally {
      setAcking(false);
    }
  };

  return (
    <div className={`${s.overlay} ${lightMode ? s.light : ''}`}>
      {flashColor && <div className={s.flashLayer} style={{ background: flashColor }} />}
      <div className={s.notifySendModal} style={flashColor ? { borderColor: flashColor } : undefined}>
        <div className={s.message}>{current.message}</div>

        <div className={`${s.actions} ${s.actionsReceiver}`}>
          <button className={`${s.btn} ${s.btnGotIt}`} onClick={() => dismiss('viewed')} disabled={acking}>I Get it</button>
        </div>
      </div>
    </div>
  );
}
